import React from 'react';

/**
 * PiPlayBigSolid icon from the solid style in media category.
 */
interface PiPlayBigSolidProps extends React.SVGProps<SVGSVGElement> {
	size?: number;
	color?: string;
	className?: string;
	ariaLabel?: string;
}

export default function PiPlayBigSolid({
	size = 24,
	color,
	className,
	ariaLabel = 'play-big icon',
	...props
}: PiPlayBigSolidProps): JSX.Element {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			style={{ color: color || 'currentColor' }}
			role="img"
			aria-label={ariaLabel}
			{...props}
		>
			<path
				d="M5 8.42c0-2.226 0-3.447.639-4.3a3.2 3.2 0 0 1 2.33-1.274c1.059-.073 2.094.59 3.997 1.811l4.027 2.583c1.613 1.035 2.548 1.635 2.946 2.578a3.2 3.2 0 0 1 0 2.484c-.398.943-1.333 1.543-2.946 2.578l-4.027 2.583c-1.903 1.221-2.938 1.884-3.997 1.811a3.2 3.2 0 0 1-2.33-1.274C5 17.147 5 15.926 5 13.7z"
				fill="currentColor"
			/>
		</svg>
	);
}
